<template>
  <div
    class="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 dark:border-gray-600 dark:bg-gray-800 sm:px-6"
  >
    <div class="mr-2 hidden sm:block">
      <ParagraphText color="text-gray-700">
        Showing
        {{ ' ' }}
        <SpanText font="font-medium">{{
          props.meta.from ? props.meta.from : 0
        }}</SpanText>
        {{ ' ' }}
        to
        {{ ' ' }}
        <SpanText font="font-medium">{{
          props.meta.to ? props.meta.to : 0
        }}</SpanText>
        {{ ' ' }}
        of
        {{ ' ' }}
        <SpanText font="font-medium">{{
          props.meta.total ? props.meta.total : 0
        }}</SpanText>
        {{ ' ' }}
        results
      </ParagraphText>
    </div>
    <div
      class="flex flex-1 justify-between sm:justify-end"
      :class="{
        'sm:hidden': pages.length < 6,
        'md:hidden': pages.length >= 6 && pages.length < 7,
        'lg:hidden': pages.length >= 7 && pages.length < 11,
        'xl:hidden': pages.length >= 11,
      }"
    >
      <PreviousNextButton
        :meta="props.meta"
        :preserveState="props.preserveState"
        :preserveScroll="props.preserveScroll"
        :only="props.only"
        type="previous"
      />
      <PreviousNextButton
        class="ml-3"
        :meta="props.meta"
        :preserveState="props.preserveState"
        :preserveScroll="props.preserveScroll"
        :only="props.only"
        type="next"
      />
    </div>
    <div
      class="hidden flex-1 items-center justify-end"
      :class="{
        'sm:flex': pages.length < 6,
        'md:flex': pages.length >= 6 && pages.length < 7,
        'lg:flex': pages.length >= 7 && pages.length < 11,
        'xl:flex': pages.length >= 11,
      }"
    >
      <div>
        <nav
          class="relative z-0 inline-flex -space-x-px rounded-md shadow-sm"
          aria-label="Pagination"
        >
          <PreviousNextButton
            :meta="props.meta"
            :preserveState="props.preserveState"
            :preserveScroll="props.preserveScroll"
            :only="props.only"
            type="previous"
            icon
          />
          <template v-for="link in pages" :key="link.label">
            <PageNumberButton
              :link="link"
              :preserveState="props.preserveState"
              :preserveScroll="props.preserveScroll"
              :only="props.only"
            />
          </template>
          <PreviousNextButton
            :meta="meta"
            :preserveState="props.preserveState"
            :preserveScroll="props.preserveScroll"
            :only="props.only"
            type="next"
            icon
          />
        </nav>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import PreviousNextButton from './PreviousNextButton.vue'
import ParagraphText from '@/Common/Text/ParagraphText.vue'
import PageNumberButton from './PageNumberButton.vue'
import SpanText from '@/Common/Text/SpanText.vue'

const props = defineProps({
  meta: Object,
  preserveState: Boolean,
  preserveScroll: Boolean,
  only: Array,
})

const pages = computed(() =>
  props.meta.links.slice(1, props.meta.links.length - 1)
)
</script>
